export default __webpack_public_path__ + "img/transparencia-icon.ba551bcf.png";